module.exports = __webpack_public_path__ + "static/media/hr.7bd313de.png";